export * from './team-in-array.pipe';
